import * as runtime from '@/api/runtime'
import {
  BatchDataShortageUserListRequest,
  BatchDataShortageUserListRequestToJSON,
  BatchStatisticsPageLoadRequest,
  BatchStatisticsPageLoadRequestToJSON
} from '@/api/models/batch'
import {
  BatchDataShortageUserListCondition,
  BatchDataShortageUserListConditionFromJSON
} from '@/api/models/batch/BatchDataShortageUserListCondition'

/**
 * 帳票作成
 */
export class BatchDataShortageUserListApi extends runtime.BaseAPI {
  async return(request: BatchDataShortageUserListRequest): Promise<number> {
    const response = await this.requestPost(
      `/batch/user-management/data-shortage-user-list`,
      BatchDataShortageUserListRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }

  async getInitialCondition(
    request: BatchStatisticsPageLoadRequest
  ): Promise<BatchDataShortageUserListCondition> {
    const response = await this.requestGet(
      `/batch/statistics/search_initial_condition`,
      BatchStatisticsPageLoadRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchDataShortageUserListConditionFromJSON(jsonValue)
    ).value()
  }
}
